import { types } from 'mobx-state-tree'
import { DOMAIN_ACTION } from '@/constants'
import { axiosPrivateHelper } from '@/utils/axiosHelper'
const axios = axiosPrivateHelper()

type CustomerDashboardType = {
  id: number
}

export const customerDashboardModel = types
  .model('DashboardModel')
  .props({
    id: types.number,
  })
  .actions((self: CustomerDashboardType) => {
    const setProfile = (value: CustomerDashboardType) => {
      self.id = value.id
    }

    const updateFeatureImage = async (payload: any, id: number) => {
      const URI: string = `${DOMAIN_ACTION.API.CUSTOMER_EVENT}/${id}`

      const res = await axios.put(`${URI}`, payload)

      return res
    }

    return {
      setProfile,
      updateFeatureImage,
    }
  })
